import {createSlice} from '@reduxjs/toolkit'
import {expressApi} from '../../api/express-api'
import {KiasDataForRenderInterface} from '../../../types/responses/data-for-render'

export const dataForRenderSlice = createSlice({
    name: 'dataForRender',
    initialState: null as KiasDataForRenderInterface,
    reducers: {},
    extraReducers: builder => {
        builder.addMatcher(
            expressApi.endpoints.getDataForRender.matchFulfilled,
            (state, {payload}) => {
                return payload.data
            }
        )
    },
})

export default dataForRenderSlice.reducer
